/** Platform detection for install onboarding + storage-survival messaging. */

export function isIos(): boolean {
  const ua = navigator.userAgent;
  const iOS = /iPad|iPhone|iPod/.test(ua);
  // iPadOS 13+ reports as Mac; detect touch to disambiguate.
  const iPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
  return iOS || iPadOS;
}

export function isStandalone(): boolean {
  const iosStandalone = (navigator as unknown as { standalone?: boolean }).standalone === true;
  const displayMode =
    typeof matchMedia === 'function' && matchMedia('(display-mode: standalone)').matches;
  return iosStandalone || displayMode;
}

/** iOS Safari in a browser tab is where storage eviction bites (spec 04). */
export function shouldNudgeInstall(): boolean {
  return isIos() && !isStandalone();
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  const units = ['KB', 'MB', 'GB'];
  let v = bytes / 1024;
  let i = 0;
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i += 1;
  }
  return `${v.toFixed(v < 10 ? 1 : 0)} ${units[i]}`;
}
